/* eslint-disable react/no-array-index-key */
import React from 'react'
import { TitleSegment, SegmentType } from './CategoryTitleVisitor'

export type SegmentStyleMap = Partial<Record<SegmentType, React.CSSProperties>>

interface SegmentListProps {
  segments: TitleSegment[]
  styleMap?: SegmentStyleMap
}

const baseStyle: React.CSSProperties = {
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}

const SegmentList: React.FC<SegmentListProps> = ({ segments, styleMap }) => (
  <>
    {segments.map((segment, i) => (
      <span key={`${segment.type}-${segment.text}-${i}`} style={{ ...baseStyle, ...styleMap?.[segment.type] }}>
        {segment.text}
      </span>
    ))}
  </>
)

export default SegmentList
